/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const neighborhoodsSchema = z.object({
      "label": z.string().optional(),
  "codePostal": z.string().optional()
      })